import {ToDoType} from './journalRecord'

export type DateString = `${number}-${number}-${number}`

export const dateFormat = 'YYYY-MM-DD'

export type ToDo = {
  id: number
  comment?: string
  creationDateUtc?: DateString
  targetStartDateUtc?: DateString
  targetEndDateUtc?: DateString
  importance?: 'critical' | 'urgent' | 'normal' | 'low'
  type?: ToDoType
  ownerId?: string
  toDoListId?: number
  plants?: {id: number; name?: string}[]
}

export type ToDoList = {
  id: number
  name: string
  ownerId: string
  projectId?: number
  creationDateUtc: DateString
}
